import {
  Box,
  Drawer,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  IconButton,
  Divider,
} from "@mui/material";
import {
  ArrowForwardIosOutlined,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

const FilterBar = ({
  actions = [],
  selectorComponentRight = <></>,
  selectorComponentLeft = <></>,
  openFilter = false,
  setOpenFilter = () => {},
  type = 0,
  widthParamsMobile = 1350,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box sx={styles.containerComponent}>
      {windowWidth >= widthParamsMobile ? (
        <Box sx={styles.containerPaper}>
          {selectorComponentLeft}
          {selectorComponentRight}
        </Box>
      ) : (
        // Renderiza o botão flutuante SpeedDial quando a tela for menor que o limite definido
        windowWidth < widthParamsMobile && (
          <SpeedDial
            ariaLabel="SpeedDial basic example"
            sx={styles?.speedDial}
            icon={<SpeedDialIcon />}
          >
            {actions?.map((action) => (
              <SpeedDialAction
                key={action?.name}
                icon={action?.icon}
                tooltipTitle={action?.name}
                onClick={action?.onClick}
              />
            ))}
          </SpeedDial>
        )
      )}
      <Drawer
        anchor="right"
        open={openFilter}
        onClose={() => setOpenFilter(false)}
      >
        <Box sx={styles.containerDrawer}>
          <Box sx={styles.containerToGoBack}>
            <IconButton onClick={() => setOpenFilter(false)}>
              <KeyboardDoubleArrowRight />
            </IconButton>
          </Box>
          <Divider />
          <Box sx={styles.boxFilters}>
            {selectorComponentLeft}
            {type == 1 && selectorComponentRight}
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default FilterBar;
